import { confirmation, notify } from "@helpers"

export default function useActions(
    salon: Model.Response<Admin.Resources.Salon>, 
    api: Admin.Models.Salon.Api, 
    methods: Admin.Models.Salon.Methods
): Admin.Models.Salon.Actions {
    const destroy = getDestroyAction(api)

    const type = {
        update: getTypeUpdateAction(api, methods)
    }
    
    const tracking = {
        notify: getTrackingNotifyAction(api)
    }

    return {
        destroy,
        type,
        tracking
    }
}

function getTrackingNotifyAction(api: Admin.Models.Salon.Api) {
    return async () => {
        const confirmed = await confirmation("Are you sure you want to notify customers regarding their tracking numbers?")
        if (!confirmed) return

        await api.notifications.tracking()
        notify("Sending notifications regarding tracking numbers...")
    }
}

function getTypeUpdateAction(api: Admin.Models.Salon.Api, methods: Admin.Models.Salon.Methods) {
    return async (type: Attributes.Salon.Type) => {
        await api.type(type)
        notify(`Changed salon's type to ${type}.`)
        methods.type.update(type)
    }
}

function getDestroyAction(    
    api: Admin.Models.Salon.Api
): Admin.Models.Salon.Actions.Destroy {
    return async () => {
        const confirmed = await confirmation("Are you you want to delete the salon? It's going to erase all the data associated with it.")
        if (!confirmed) return
        
        await api.destroy()
        notify("The salon was successfully deleted.")
    }
}